// ko strings for messages/home.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const home: Dict = {
  "home.seo.title": "Jammable | 좋아하는 목소리로 AI 커버 만들기",
  "home.seo.description":
    "Jammable에서 몇 초 만에 AI 커버를 만들어 보세요. 커뮤니티가 올린 수천 개의 AI 목소리 모델을 지금 바로 창작에 활용할 수 있어요.",
  "home.seo.ogTitle":
    "Jammable | 좋아하는 목소리로 AI 커버 만들기 | AI 음악 제작",
  "home.seo.imageAlt": "Jammable - AI 커버 만들기",

  // Hero: "<before> <highlight> <after>".
  "home.hero.views": "TikTok, YouTube, Instagram 조회수 100억 회 이상",
  "home.hero.titleBefore": "좋아하는 목소리로",
  "home.hero.titleHighlight": "AI 커버",
  "home.hero.titleAfter": "만들기",
  "home.hero.subtitle":
    "10만 개 이상의 AI 목소리 중 하나를 고르고 오디오를 추가하면 몇 초 만에 완성돼요.",
  "home.hero.decorVoice": "AI 목소리",
  "home.hero.decorCover": "커버",
  "home.hero.searchLabel": "목소리 검색",
  "home.hero.searchPlaceholder": "10만 개 이상의 목소리 검색",
  "home.hero.searchButton": "검색",
  "home.hero.makeCover": "커버 만들기",

  "home.categories.all": "모든 카테고리 보기",
  "home.recent": "이어서 하기",
  "home.trending": "지금 인기",
  "home.seeAll": "모두 보기",

  // "<before> <highlight>"
  "home.train.kicker": "10만 개 이상의 목소리가 이렇게 시작됐어요",
  "home.train.titleBefore": "나만의",
  "home.train.titleHighlight": "AI 목소리 만들기",
  "home.train.body":
    "몇 개의 샘플로 목소리를 만들고, 누구에게도 없는 목소리로 커버를 만들어 보세요.",
  "home.train.step1": "샘플 업로드",
  "home.train.step1Sub": "깨끗한 보컬이 담긴 짧은 클립이면 충분해요",
  "home.train.step2": "모델 학습",
  "home.train.step2Sub": "몇 분 안에 나만의 목소리가 준비돼요",
  "home.train.step3": "커버 만들기",
  "home.train.step3Sub": "원할 때 언제든 커버에 사용하세요",

  "home.topCollections": "인기 컬렉션",
  "home.collabs": "인기 콜라보",
  "home.collection": "컬렉션",

  // Cards (components/home/JamCards.tsx)
  "home.card.uses": "{n}회 사용",
  "home.card.voices": "목소리 {n}개",
  "home.card.likes": "좋아요 {n}개",
  "home.card.by": "@{user}",
  "home.card.madeToday": "오늘 {n}개 제작",
  "home.card.makeDuet": "이 듀엣 만들기",

  // Discord CTA (components/DiscordCta.js)
  "home.discord.bannerSub":
    "커버를 공유하고, 목소리를 요청하고, 커뮤니티의 도움을 받아 보세요",
  "home.discord.online": "{n}명 접속 중",
  "home.discord.members": "멤버 {n}명",
  "home.discord.joinDiscord": "Discord 참여하기",
  "home.discord.softSub": "커버 공유, 목소리 요청, 꿀팁까지",
  "home.discord.cardSub": "도움 받기, 커버 공유, 새 목소리 찾기",
  "home.discord.join": "참여하기",
};

export default home;
